import MaxWidthContainer from 'components/MaxWidthContainer';
import { ArrowRightSvg } from 'components/SorraSvg';
import { Field, FieldArray, Form, Formik } from 'formik';
import useRWD from 'hooks/useRWD';
import { NextSeo } from 'next-seo';
import React from 'react';
import api from 'utils/api';
import * as Yup from 'yup';

const { useState, useEffect, useRef } = React;

const I18N = {
  en: {
    nav: [
      { label: 'HOME', href: '#home' },
      { label: 'ABOUT', href: '#about' },
      { label: 'WHY ATTEND?', href: '#why-attend' },
      { label: 'AGENDA', href: '#agenda' },
    ],
    reserveSeat: 'Reserve My Seat',
    // Hero
    heroSubtitle:
      'SORRA BEAUTY BRAND SEMINAR · UNLOCK THE 2026 BEAUTY WORD-OF-MOUTH MARKETING PLAYBOOK',
    heroTitle1: 'The Trust Loop:',
    heroTitle2: 'Future of Beauty Word-of-Mouth',
    details: 'DETAILS',
    detailDate: 'May 14, 2026 (Thu)',
    detailTime: '14:00 - 18:00',
    detailTimeSub: '(Registration starts at 14:00)',
    detailLocation: 'Eaton Club Central · 5/F, Champion Tower',
    detailSeats: 'Limited to 60 Seats · Invitation Only',
    viewAgenda: 'View Agenda',
    // Speaker
    speakerTitle: ['Speaker', 'Lineup'],
    speakers: [
      {
        name: 'Jessie Chan',
        title: 'Founder',
        company: 'Sorra Hong Kong/\nTaiwan',
        topic: 'TOPIC 01 · WOM',
        image: '/images/2026/seminar/jessie.png',
      },
      {
        name: 'Nelson Choi',
        title: 'VP of Growth',
        company: 'Markato',
        topic: 'TOPIC 01 · WOM',
        image: '/images/2026/seminar/nelson.png',
      },
      {
        name: 'Karena Tsang',
        title: 'Senior Marketing Manager',
        company: 'Sephora',
        topic: 'TOPIC 01 · WOM',
        image: '/images/2026/seminar/karena.png',
      },
      {
        name: 'Beatrice Wong',
        title: 'Founder & Creative Director',
        company: 'Dino & Parrot',
        topic: 'TOPIC 02 · THREADS',
        image: '/images/2026/seminar/beatrice.png',
      },
      {
        name: 'Samson Fong',
        title: 'Head of Growth & Partner',
        company: 'Inspect Element',
        topic: 'Topic 03 - SEO + GEO',
        image: '/images/2026/seminar/samson.png',
      },
    ],
    // Brand Logos
    brandLogosText:
      'Speakers and their teams have helped the following top brands achieve growth',
    // About
    aboutLabel: 'ABOUT THIS SEMINAR',
    aboutTitle: ['The ', 'Future of Beauty Discovery', ' has arrived.'],
    aboutSubtitle: 'Is your brand ready?',
    aboutP1:
      '<strong>Hard-selling is out.</strong> When searching for "2026 Must-Buy Serums" or "Best Value Skincare", consumers now look into ingredient breakdowns, compare prices, and hunt for honest reviews for their skin types.',
    aboutP2:
      "As HK and Taiwan's most trusted beauty review platform, Sorra invites top Beauty Marketing leaders to unlock the <strong>3 growth engines for 2026:</strong>",
    growthEngines: [
      'WOM (Authentic Word-of-Mouth)',
      'Threads Community',
      'AI Search (GEO)',
    ],
    stats: [
      { value: '60', label: 'Guests' },
      { value: '4', label: 'Speakers' },
      { value: '3', label: 'Topics' },
      { value: '4h', label: 'Programme' },
    ],
    // Why Attend
    whyAttendLabel: 'WHY ATTEND?',
    whyAttendTitle: ['Finding ', 'Beauty Marketing', ' tougher?'],
    whyAttendSubtitle: 'We get it.',
    whyAttendDesc:
      'Before purchasing a serum, consumers are already checking Threads for real reviews and searching sorra.net for pros, cons, and affordable dupes. Stop wasting your ad budget and master the 3 core pillars to win trust:',
    pillars: [
      {
        number: '01',
        title: 'Real Reviews',
        desc: 'Turn WOM into your long-term trust moat.',
      },
      {
        number: '02',
        title: 'Threads Guide',
        desc: 'Master KOC collabs, viral content, and crisis management.',
      },
      {
        number: '03',
        title: 'SEO to GEO',
        desc: 'Make AI recommend your brand first.',
      },
    ],
    // Registration
    regTitle: 'RESERVE YOUR SEAT',
    regSubtitle: 'Invitation subject to review · Limited to 60 seats',
    regAttendeeName: (n) => `Attendee ${n}'s Name`,
    regCompany: 'Company Name',
    regJobTitle: 'Job Title',
    regEmail: 'Company Email',
    regPhone: 'Contact Number',
    regRemove: (n) => `Remove attendee ${n}`,
    regAdd: 'Add attendee',
    regAddMax: 'Add attendee (Max 3 attendees under same company)',
    regPainPointTitle: 'What is your biggest pain point in beauty marketing?',
    regPainPointSub: '(Select all that apply)',
    painPoints: [
      'Difficulty collecting authentic product reviews and word-of-mouth (WOM)',
      'Cannot find a starting point for Threads, resulting in low conversion',
      'Lack of brand exposure in AI Search (GEO)',
      'Difficult to stand out against affordable alternatives',
      'Others',
    ],
    regSubmit: 'Confirm Registration',
    regSubmitting: 'Submitting...',
    regDisclaimer1: 'This event is invitation-only and subject to review.',
    regDisclaimer2:
      'Successful registrants will receive a confirmation email within 3 working days.',
    // Placeholders
    phName: (n) => `Attendee ${n}`,
    phCompany: 'Company',
    phJobTitle: 'e.g. Marketing Manager, Brand Director',
    phEmail: 'you@company.com',
    phPhone: '+852 XXXX XXXX',
  },
  zh: {
    nav: [
      { label: 'HOME', href: '#home' },
      { label: 'ABOUT', href: '#about' },
      { label: 'WHY ATTEND?', href: '#why-attend' },
      { label: 'AGENDA', href: '#agenda' },
    ],
    reserveSeat: '預留席位',
    // Hero
    heroSubtitle: '解鎖 2026 美妝口碑營銷實戰指南',
    heroTitle1: 'The Trust Loop:',
    heroTitle2: '美妝口碑新未來',
    details: 'DETAILS',
    detailDate: '2026 年 5 月 14 日（星期四）',
    detailTime: '14:00 - 18:00',
    detailTimeSub: '（14:00 開始登記報到）',
    detailLocation: '中環花園道三號 冠君大廈 5 樓（Eaton Club Central）',
    detailSeats: '名額限 60 位',
    viewAgenda: 'View Agenda',
    // Speaker
    speakerTitle: ['主講', '陣容'],
    speakers: [
      {
        name: 'Jessie Chan',
        title: 'Sorra 香港/台灣',
        company: 'Founder',
        topic: 'TOPIC 01 · WOM',
        image: '/images/2026/seminar/jessie.png',
      },
      {
        name: 'Nelson Choi',
        title: 'VP of Growth',
        company: 'Markato',
        topic: 'TOPIC 01 · WOM',
        image: '/images/2026/seminar/nelson.png',
      },
      {
        name: 'Karena Tsang',
        title: 'Sephora',
        company: 'Senior Marketing Manager',
        topic: 'TOPIC 01 · WOM',
        image: '/images/2026/seminar/karena.png',
      },
      {
        name: 'Beatrice Wong',
        title: 'Threads 博主 @kayingwbe',
        company: '廣告公司 Dino & Parrot 創辦人',
        topic: 'TOPIC 02 · THREADS',
        image: '/images/2026/seminar/beatrice.png',
      },
      {
        name: 'Samson Fong',
        title: 'Inspect Element',
        company: 'Head of Growth & Partner',
        topic: 'Topic 03 - SEO + GEO',
        image: '/images/2026/seminar/samson.png',
      },
    ],
    // Brand Logos
    brandLogosText: '講者與團隊曾協助以下頂尖品牌實現增長',
    // About
    aboutLabel: 'ABOUT THIS SEMINAR',
    aboutTitle: ['在2026年，美妝消費者正在', '悄悄改變...', ''],
    aboutSubtitle: '你的品牌準備好了嗎？',
    aboutP1:
      '尋找化妝護膚品時，消費者不再看硬銷廣告，而是看<strong>口碑、成份分析、比價格</strong>，並尋找適合自己膚質的<strong>真實評價</strong>！',
    aboutP2:
      '作為港台地區最具公信力化妝品及護膚品評驗平台，Sorra 誠邀頂尖美妝品牌的 Marketing 決策者，一起解鎖三大 2026 增長引擎：<strong>WOM (真實口碑)、Threads 社群 與 AI 搜尋 (GEO)。</strong>',
    growthEngines: [
      'WOM (Authentic Word-of-Mouth)',
      'Threads Community',
      'AI Search (GEO)',
    ],
    stats: [
      { value: '60', label: 'Guests' },
      { value: '4', label: 'Speakers' },
      { value: '3', label: 'Topics' },
      { value: '4h', label: 'Programme' },
    ],
    // Why Attend
    whyAttendLabel: 'WHY ATTEND?',
    whyAttendTitle: ['現在做', 'Beauty Marketing', '越來越難？'],
    whyAttendSubtitle: '我們懂！',
    whyAttendDesc:
      '買一瓶專櫃精華前，消費者早就滑過 Threads 上的心得，又上Sorra查過優缺點和有沒有平價替代品了。',
    pillars: [
      {
        number: '01',
        title: '真實評價',
        desc: '將客觀口碑(WOM)轉化為品牌長期的信任護城河。',
      },
      {
        number: '02',
        title: 'Threads 實戰',
        desc: '掌握 KOC 合作、打造爆款貼文與公關危機處理。',
      },
      {
        number: '03',
        title: '佈局 GEO',
        desc: '從SEO升級，讓 AI 優先推薦你的品牌。',
      },
    ],
    // Registration
    regTitle: 'RSVP 預留席位',
    regSubtitle: '邀請審核制：名額限 60 位',
    regAttendeeName: (n) => `姓名`,
    regCompany: '公司名稱',
    regJobTitle: '職稱',
    regEmail: '公司電郵',
    regPhone: '聯絡電話',
    regRemove: (n) => `移除名額`,
    regAdd: '加入新名額',
    regAddMax: 'Add attendee (Max 3 attendees under same company)',
    regPainPointTitle: '您在美妝營銷中最大的痛點是什麼？',
    regPainPointSub: '(可複選)',
    painPoints: [
      '難以收集真實產品口碑',
      'Threads 經營找不到的切入點',
      '品牌在AI搜尋 (GEO) 中缺乏曝光',
      '難以在專櫃與平替競爭中脫穎而出',
      '其它',
    ],
    regSubmit: '確認報名',
    regSubmitting: '提交中...',
    regDisclaimer1: '本活動僅限受邀者參加，需經審核。',
    regDisclaimer2: '報名成功者將於 3 個工作天內收到確認電郵。',
    // Placeholders
    phName: (n) => `Attendee ${n}`,
    phCompany: 'Company',
    phJobTitle: 'e.g. Marketing Manager, Brand Director',
    phEmail: 'you@company.com',
    phPhone: '+852 XXXX XXXX',
  },
};

const BRAND_LOGOS = [
  '/images/2026/seminar/logo-beame.png',
  '/images/2026/seminar/logo-sasa.png',
  '/images/2026/seminar/logo-shopback.png',
  '/images/2026/seminar/logo-sorra.png',
  '/images/2026/seminar/logo-xiaomi.png',
  '/images/2026/seminar/logo-zenyum.png',
  '/images/2026/seminar/logo-langham.png',
  '/images/2026/seminar/logo-netvigator.png',
  '/images/2026/seminar/logo-tamjaisamgor.jpg',
  '/images/2026/seminar/logo-nowtv.png',
];

function SeminarPage() {
  const [lang, setLang] = useState('en');

  return (
    <div className="min-h-screen bg-white">
      <NextSeo
        title="The Trust Loop: Future of Beauty Word-of-Mouth | SORRA 2026 Seminar"
        description="SORRA Beauty Brand Seminar - Unlock the 2026 Beauty Word-of-Mouth Marketing Playbook"
      />

      <SeminarNavbar lang={lang} setLang={setLang} />

      <HeroSection lang={lang} />

      <SpeakerSection lang={lang} />

      <BrandLogosSection lang={lang} />

      <AboutSection lang={lang} />

      <AgendaSection lang={lang} />

      <RegistrationSection lang={lang} />
    </div>
  );
}

function SeminarNavbar({ lang, setLang }) {
  return (
    <nav className="fixed left-0 right-0 top-4 z-50">
      <MaxWidthContainer className="px-4">
        <div className="font-noto-sans-tc flex items-center justify-between rounded-xl bg-white/40 px-4 py-2 shadow-md backdrop-blur-md lg:px-10 lg:py-3">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-1">
            <img
              src="/images/2026/seminar/logo-sorra.png"
              alt="SORRA"
              className="h-5 w-auto lg:h-8"
            />
          </a>

          <div className="hidden items-center gap-6 font-rubik lg:flex">
            {I18N[lang].nav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-base font-medium text-[#4A4A4A] transition hover:font-black hover:text-sorra-pink"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Lang + CTA */}
          <div className="flex items-center gap-2 lg:gap-2">
            <button
              onClick={() => setLang('en')}
              className={`rounded-full px-4 py-2 text-xs font-bold transition lg:text-sm ${
                lang === 'en'
                  ? 'bg-white stroke-[#FCE1E5] stroke-1 text-sorra-pink'
                  : 'text-sorra-gray-800 hover:bg-gray-100'
              }`}
            >
              EN
            </button>
            <button
              onClick={() => setLang('zh')}
              className={`rounded-full px-4 py-2 text-xs font-bold transition lg:text-sm ${
                lang === 'zh'
                  ? 'bg-white stroke-[#FCE1E5] stroke-1 text-sorra-pink'
                  : 'text-sorra-gray-800 hover:text-sorra-pink'
              }`}
            >
              中
            </button>
            <a
              href="#register"
              className="hidden items-center gap-1 rounded-xl border border-sorra-pink bg-white px-4 py-3 text-base font-bold text-sorra-pink transition hover:bg-sorra-pink hover:text-white lg:flex"
            >
              {I18N[lang].reserveSeat}
              <div className="ml-3 h-5 w-5">
                <ArrowRightSvg />
              </div>
            </a>
          </div>
        </div>
      </MaxWidthContainer>
    </nav>
  );
}

function HeroSection({ lang }) {
  const t = I18N[lang];
  const isLg = useRWD();
  return (
    <section
      id="home"
      className="relative overflow-hidden pb-6 pt-12 lg:pt-24"
      style={{
        background: `
          radial-gradient(ellipse 80% 80% at 85% 20%, rgba(255,169,108,0.8) 0%, rgba(241,107,124,0) 70%),
          radial-gradient(ellipse 60% 60% at 20% 80%, rgba(216,116,123,0.6) 0%, rgba(241,107,124,0) 70%),
          radial-gradient(ellipse 60% 60% at 80% 90%, rgba(216,116,123,0.6) 0%, rgba(241,107,124,0) 70%),
          #F98392
        `,
      }}
    >
      <MaxWidthContainer
        className={`relative px-6 pb-12 pt-8 lg:px-12 lg:pb-20 lg:pt-12 ${lang === 'zh' ? 'lg:pb-20' : ''}`}
      >
        <div className="pointer-events-none absolute right-15 top-20 hidden h-[457px] w-[454px] lg:block">
          <img
            src="/images/2026/seminar/hero-icons.png"
            alt=""
            className="h-full w-full object-contain"
          />
        </div>

        <div className="relative z-10 font-rubik lg:max-w-[941px]">
          <div className="mb-6 flex items-center gap-3">
            <span className="inline-block h-[2px] w-[60px] bg-white" />
            <p className="text-[11px] font-medium tracking-tight text-white/90 lg:text-sm">
              {t.heroSubtitle}
            </p>
          </div>

          <h1 className="mb-6 lg:mb-8">
            <span
              className="block font-rubik text-[40px] font-bold leading-[1] text-white lg:mb-3 lg:text-[60px] lg:leading-[1.2]"
              style={{
                textShadow: '0px 4px 50px rgba(255, 255, 255, 0.5)',
              }}
            >
              {t.heroTitle1}
            </span>
            <span
              className="block font-rubik text-[40px] font-bold leading-[1] text-white lg:text-[80px] lg:leading-[1]"
              style={{
                textShadow: '0px 4px 50px rgba(255, 255, 255, 0.5)',
              }}
            >
              {t.heroTitle2}
            </span>
          </h1>

          <div className="mb-6">
            <p className="mb-2 text-[13px] font-medium uppercase tracking-wider text-white/80 lg:mb-3 lg:text-base">
              {t.details}
            </p>
            <div className="flex flex-col gap-2 lg:flex-row lg:flex-wrap lg:gap-3">
              <DetailBadge
                icon="/images/2026/seminar/icon-calendar.svg"
                text={t.detailDate + (isLg ? '' : ` · ${t.detailTime}`)}
              />
              <DetailBadge
                icon="/images/2026/seminar/icon-clock.svg"
                text={t.detailTime}
                sub={t.detailTimeSub}
              />
            </div>
            <div className="mt-2 flex flex-col gap-2 lg:flex-row lg:flex-wrap lg:gap-3">
              <DetailBadge
                icon="/images/2026/seminar/icon-location.svg"
                text={t.detailLocation}
              />
              <DetailBadge
                icon="/images/2026/seminar/icon-people.svg"
                text={t.detailSeats}
              />
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="font-noto-sans-tc flex flex-col gap-3 lg:flex-row lg:gap-4">
            <a
              href="#register"
              className="flex items-center justify-center gap-2 rounded-xl border-2 border-white bg-white px-8 py-3 text-base text-sorra-pink transition hover:bg-white/90 lg:text-lg"
            >
              {t.reserveSeat}
              <div className="h-5 w-5">
                <ArrowRightSvg />
              </div>
            </a>
            <a
              href="#agenda"
              className="flex items-center justify-center rounded-xl border border-white px-8 py-3 text-base text-white transition hover:bg-white/10 lg:text-lg"
            >
              {t.viewAgenda}
            </a>
          </div>
        </div>
      </MaxWidthContainer>
    </section>
  );
}

function DetailBadge({ icon, text, sub }) {
  return (
    <div
      className="inline-flex w-fit items-center gap-2 rounded-full border border-white/30 px-2 py-1 text-[14px] text-white shadow-sm backdrop-blur-md lg:px-4 lg:py-2 lg:text-[14px]"
      style={{ background: 'rgba(252, 225, 229, 0.15)' }}
    >
      <img src={icon} alt="" className="h-4 w-4 shrink-0" />
      <span className="font-medium">{text}</span>
      {sub && <span className="text-xs text-white/80">{sub}</span>}
    </div>
  );
}

function SpeakerSection({ lang }) {
  const t = I18N[lang];
  return (
    <section
      id="about"
      className="relative -mt-12 rounded-t-[60px] bg-white px-6 pb-6 pt-16 lg:-mt-12 lg:px-12 lg:pb-15 lg:pt-20"
    >
      <div className="mx-auto max-w-[1200px]">
        <h2 className="mb-10 font-rubik text-[20px] lg:text-[48px]">
          <span className="font-semibold text-sorra-pink">
            {t.speakerTitle[0]}
          </span>
          {lang == 'en' ? ' ' : ''}
          <span className="text-sorra-gray-900">{t.speakerTitle[1]}</span>
        </h2>

        <div className="hidden lg:mx-6 lg:my-[31px] lg:grid lg:grid-cols-5 lg:gap-8">
          {t.speakers.map((speaker) => (
            <SpeakerCardDesktop key={speaker.name} speaker={speaker} />
          ))}
        </div>

        <div className="flex flex-col gap-8 lg:hidden">
          {t.speakers.map((speaker) => (
            <SpeakerCardMobile key={speaker.name} speaker={speaker} />
          ))}
        </div>
      </div>
    </section>
  );
}

function SpeakerCardDesktop({ speaker }) {
  return (
    <div className="flex flex-col items-center text-center font-rubik">
      <div className="mb-4 h-[172px] w-[172px] overflow-hidden rounded-full bg-gray-100">
        <img
          src={speaker.image}
          alt={speaker.name}
          className="h-full w-full object-cover"
        />
      </div>
      <h3 className="text-[24px] font-medium text-sorra-pink">
        {speaker.name}
      </h3>
      <p className="mt-1 text-[18px] text-sorra-gray-800">{speaker.title},</p>
      <p className="text-[18px] text-sorra-gray-800">{speaker.company}</p>
      <div className="mt-4 inline-flex items-center gap-1 rounded-lg border border-[#EDD9D4] px-3 py-1.5 text-[18px] font-medium text-[#0F1929]">
        <img src="/svgs/tag.svg" alt="" className="h-5 w-5 shrink-0" />
        <span>{speaker.topic}</span>
      </div>
    </div>
  );
}

function SpeakerCardMobile({ speaker }) {
  return (
    <div className="flex items-start gap-4">
      <div className="h-[120px] w-[120px] shrink-0 overflow-hidden rounded-full bg-gray-100">
        <img
          src={speaker.image}
          alt={speaker.name}
          className="h-full w-full object-cover"
        />
      </div>
      <div>
        <h3 className="font-rubik text-lg font-medium text-sorra-pink">
          {speaker.name}
        </h3>
        <p className="font-rubik text-[14px] text-sorra-gray-800">
          {speaker.title},
        </p>
        <p className="font-rubik text-[14px] text-sorra-gray-800">
          {speaker.company}
        </p>
        <div className="mt-2 inline-flex items-center gap-1 rounded-lg border border-gray-200 px-3 py-1.5 font-rubik text-[14px] font-medium text-sorra-gray-900">
          <img src="/svgs/tag.svg" alt="" className="h-4 w-4 shrink-0" />
          <span>{speaker.topic}</span>
        </div>
      </div>
    </div>
  );
}

function BrandLogosSection({ lang }) {
  const t = I18N[lang];
  return (
    <section className="overflow-hidden bg-white pb-6 pt-6 lg:pb-10 lg:pt-0">
      <div className="mx-auto max-w-[1200px] px-6 lg:px-12">
        <p className="mb-8 text-center text-sm text-sorra-gray-500">
          {t.brandLogosText}
        </p>
      </div>
      <div className="relative w-full overflow-hidden">
        <div className="flex w-max animate-infinite-left-15 items-center">
          {[0, 1].map((copyIdx) => (
            <div
              key={copyIdx}
              className="flex shrink-0 items-center gap-12 pr-12 lg:gap-16 lg:pr-16"
            >
              {BRAND_LOGOS.map((logo, idx) => (
                <img
                  key={idx}
                  src={logo}
                  alt=""
                  className="h-8 w-auto shrink-0 object-contain lg:h-10"
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function AboutSection({ lang }) {
  const t = I18N[lang];
  const { isLg } = useRWD();
  return (
    <section
      id="about-seminar"
      className="relative overflow-clip px-6 py-16 lg:px-12 lg:py-20"
      style={{
        background: 'linear-gradient(to bottom, #FFFCFA 0%, #FFE8E8 100%)',
      }}
    >
      {/* Desktop: decorative circle top-right */}
      <div
        className="pointer-events-none absolute hidden h-[800px] w-[800px] rounded-full lg:block"
        style={{
          background:
            'radial-gradient(circle, #FBC6D1 0%, rgba(255,249,245,0) 70%)',
          right: '-400px',
          top: '-240px',
        }}
      />
      <MaxWidthContainer className="relative z-10 mb-10 lg:mb-20 lg:max-w-[1376px]">
        <div className="relative flex flex-col gap-10 lg:flex-row lg:gap-16">
          {/* Decorative circles */}
          <div
            className="pointer-events-none absolute block h-[394px] w-[393px] rounded-full opacity-15 lg:hidden"
            style={{
              background: '#FF6079',
              filter: 'blur(8px)',
              left: '-63%',
              top: '180px',
            }}
          />
          <div
            className="pointer-events-none absolute block h-[301px] w-[308px] rounded-full opacity-15 lg:hidden"
            style={{
              background: '#FFCC80',
              filter: 'blur(8px)',
              right: '-50%',
              top: '-80px',
            }}
          />
          <div className="">
            <div className="mb-6 flex items-center gap-3">
              <span className="inline-block h-[2px] w-8 bg-sorra-pink" />
              <p className="text-[13px] font-semibold uppercase tracking-wider text-sorra-gray-800 lg:text-[18px]">
                {t.aboutLabel}
              </p>
            </div>

            <h2 className="mb-4 font-rubik text-[28px] text-sorra-gray-900 lg:text-[48px] lg:leading-[1.2]">
              {t.aboutTitle[0]}
              <span className="font-semibold text-sorra-pink">
                {t.aboutTitle[1]}
              </span>
              {t.aboutTitle[2]}
            </h2>

            <p className="mb-6 font-rubik text-[17px] italic text-sorra-gray-800 lg:text-[24px]">
              {t.aboutSubtitle}
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-6 lg:flex-row lg:gap-6">
          <div className="lg:flex-1">
            <div className="mb-6 font-rubik text-base leading-relaxed text-[#111928] lg:text-lg">
              <p
                className="mb-4"
                dangerouslySetInnerHTML={{ __html: t.aboutP1 }}
              />
              <p dangerouslySetInnerHTML={{ __html: t.aboutP2 }} />
            </div>

            <div className="flex flex-wrap gap-2">
              {t.growthEngines.map((engine) => (
                <span
                  key={engine}
                  className="relative rounded-full px-3 py-2 font-rubik text-base font-medium italic lg:px-4"
                  style={{
                    background:
                      'linear-gradient(94deg, #FF7C92 16.71%, #FFB68C 95.36%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  {/* 白色半透明背景 */}
                  <span className="absolute inset-0 -z-10 rounded-full bg-white/50" />
                  {/* 漸層邊框 */}
                  <span
                    className="absolute inset-0 rounded-full"
                    style={{
                      padding: '1px',
                      background:
                        'linear-gradient(94deg, #FF7C92 16.71%, #FFB68C 95.36%)',
                      WebkitMask:
                        'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                      WebkitMaskComposite: 'xor',
                      maskComposite: 'exclude',
                    }}
                  />
                  {engine}
                </span>
              ))}
            </div>
          </div>

          <div className="bg-red grid grid-cols-2 gap-3 self-center lg:w-[436px] lg:gap-4">
            {t.stats.map((stat) => (
              <div
                key={stat.label}
                className="flex items-center gap-2 rounded-2xl border border-white/60 bg-white/20 px-6 py-5 shadow-md backdrop-blur-md lg:px-6 lg:py-10"
              >
                <span className="font-rubik text-[28px] font-medium text-sorra-pink lg:text-[36px]">
                  {stat.value}
                </span>
                <span className="font-rubik text-base text-[#9B9B9B] lg:text-[20px] lg:font-medium">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </MaxWidthContainer>

      {isLg && (
        <img
          src="/images/2026/seminar/circle2.png"
          alt=""
          className="pointer-events-none absolute -bottom-16 -left-[10%] z-0 w-[200px] opacity-100 lg:-bottom-[20%] lg:-left-[1%] lg:w-[1146px]"
        />
      )}

      <MaxWidthContainer
        id="why-attend"
        className="relative z-10 lg:max-w-[1376px]"
      >
        <div className="mb-6 flex items-center gap-3">
          <span className="inline-block h-[2px] w-8 bg-sorra-pink" />
          <p className="text-[13px] font-semibold uppercase tracking-wider text-sorra-gray-800 lg:text-[18px]">
            {t.whyAttendLabel}
          </p>
        </div>

        <div className="flex flex-col gap-10 lg:flex-row lg:gap-16">
          <div className="lg:flex-1">
            <h2 className="mb-4 font-rubik text-[28px] text-sorra-gray-900 lg:text-[40px] lg:text-[48px] lg:leading-[1.2]">
              {t.whyAttendTitle[0]}
              <span className="font-semibold text-sorra-pink">
                {t.whyAttendTitle[1]}
              </span>{' '}
              {t.whyAttendTitle[2]}
            </h2>

            <p className="mb-6 font-rubik italic text-sorra-gray-800 lg:text-[24px]">
              {t.whyAttendSubtitle}
            </p>

            <p className="mb-8 font-rubik text-sm leading-relaxed text-[#111928] lg:text-lg">
              {t.whyAttendDesc}
              {lang == 'zh' && (
                <>
                  <br />{' '}
                  停止盲目消耗廣告Budget，掌握三大核心贏得消費者的真正信任：
                </>
              )}
            </p>

            <div className="flex flex-col gap-6 rounded-2xl border border-white bg-white/20 px-4 py-6 shadow-lg backdrop-blur-md lg:px-8 lg:py-10">
              {t.pillars.map((pillar) => (
                <div key={pillar.number} className="flex gap-4">
                  <span
                    className="w-[70px] shrink-0 font-rubik text-[40px] font-semibold italic leading-none lg:w-[90px] lg:text-[64px]"
                    style={{
                      background:
                        'linear-gradient(94deg, #FF7C92 16.71%, #FFB68C 95.36%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      opacity: 0.5,
                    }}
                  >
                    {pillar.number}
                  </span>
                  <div className="flex flex-col gap-y-1">
                    <h3
                      className="font-rubik text-base font-semibold leading-[1.5] lg:text-[24px]"
                      style={{
                        background:
                          'linear-gradient(94deg, #FF7C92 16.71%, #FFB68C 95.36%)',
                        background:
                          'linear-gradient(94deg, color(display-p3 1 0.5202 0.581) 16.71%, color(display-p3 0.9642 0.7245 0.5738) 95.36%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                      }}
                    >
                      {pillar.title}
                    </h3>
                    <p className="font-rubik text-lg leading-[1.5] text-[#111928]">
                      {pillar.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex hidden items-center justify-center lg:block lg:w-[400px]">
            <img
              src="/images/2026/seminar/why-attend-phone.png"
              alt=""
              className="h-auto w-[398px] object-contain lg:w-[398px]"
            />
          </div>
        </div>
      </MaxWidthContainer>
    </section>
  );
}

function AgendaSection({ lang }) {
  const { isLg } = useRWD();
  return (
    <section
      id="agenda"
      className="relative overflow-hidden px-0 pb-0 pt-0 lg:px-12 lg:pt-20"
      style={{
        background: 'linear-gradient(to bottom, #FFFCFA 0%, #FFF3F3 100%)',
      }}
    >
      <img
        src="/images/2026/seminar/circle.png"
        alt=""
        className="pointer-events-none absolute -right-[35%] top-10 w-[200px] w-[455px] opacity-100 lg:-right-[15%] lg:-top-10 lg:w-[950px]"
      />
      {isLg && (
        <img
          src="/images/2026/seminar/circle.png"
          alt=""
          className="pointer-events-none absolute -bottom-16 -left-[10%] w-[200px] -scale-x-100 -scale-y-100 opacity-100 lg:-bottom-20 lg:-left-[18%] lg:w-[950px]"
        />
      )}
      <div className="mx-auto lg:max-w-[1440px]">
        {/* Section Label */}
        <div className="mb-6 flex items-center gap-3">
          <img
            src={
              isLg
                ? `/images/2026/seminar/agenda-${lang}-desktop.png`
                : `/images/2026/seminar/agenda-${lang}-mobile.png`
            }
            alt=""
            className="object-contain"
          />
        </div>
      </div>
    </section>
  );
}

const EMPTY_ATTENDEE = {
  name: '',
  company: '',
  jobTitle: '',
  email: '',
  phone: '',
};

const registrationSchema = Yup.object({
  attendees: Yup.array()
    .of(
      Yup.object({
        name: Yup.string().required('Name is required'),
        company: Yup.string().required('Company is required'),
        jobTitle: Yup.string().required('Job title is required'),
        email: Yup.string()
          .email('Invalid email')
          .required('Email is required'),
        phone: Yup.string().required('Phone is required'),
      })
    )
    .min(1),
  painPoints: Yup.array().of(Yup.string()),
});

const INPUT_CLASS =
  'w-full rounded-xl border border-sorra-pink/30 bg-white px-4 py-3 text-sm text-sorra-gray-900 placeholder-sorra-gray-500 outline-none focus:border-sorra-pink';
const ERROR_CLASS = 'mt-1 text-xs text-red-500';

function RegistrationSection({ lang }) {
  const t = I18N[lang];
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        attendees: values.attendees.map((a) => ({
          name: a.name,
          email: a.email,
          phone: a.phone,
          job_title: a.jobTitle,
          company_name: a.company,
        })),
        options: values.painPoints.map((p) => t.painPoints.indexOf(p)),
      };

      await api.request({
        method: 'POST',
        url: '/api/v3/seminar2026/attendees',
        data: payload,
      });

      setIsSubmitted(true);
    } catch (e) {
      console.error(e);
      alert(
        lang === 'zh'
          ? '提交失敗，請稍後再試'
          : 'Submission failed, please try again'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      id="register"
      className="-mt-10 px-6 py-16 lg:px-12 lg:py-15"
      style={{
        background: 'linear-gradient(to bottom, #FFF3F3 0%, #FF7C92 100%)',
      }}
    >
      <MaxWidthContainer>
        <div className="mx-auto max-w-[800px]">
          {isSubmitted ? (
            <div
              className="flex flex-col items-center rounded-3xl border border-white px-6 py-16 shadow-lg lg:px-12 lg:py-24"
              style={{
                background:
                  'linear-gradient(to bottom, #FFFFFF 0%, #FCE1E5 100%)',
              }}
            >
              <img
                src="/images/2026/seminar/success.png"
                className="mb-4 h-10 w-auto"
              />
              <h2
                className="mb-2 inline-block font-rubik text-3xl font-bold lg:text-4xl"
                style={{
                  background:
                    'linear-gradient(94deg, #FF7C92 16.71%, #FFB68C 95.36%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {lang === 'zh' ? '確認報名' : 'YOUR APPLICATION IS IN.'}
              </h2>
              <p className="mb-8 text-sm font-medium uppercase tracking-wider text-sorra-pink/60">
                WE&apos;LL BE IN TOUCH.
              </p>
              <p className="mb-2 text-center text-base text-sorra-gray-800">
                {lang === 'zh'
                  ? '本活動採審核制，成功報名者將收到確認電郵。'
                  : 'Our team reviews every application and a confirmation email will be sent to you once your request is finalized.'}
              </p>
              <p className="mb-8 text-center text-base text-sorra-gray-800">
                {lang === 'zh'
                  ? '若找不到我們的郵件，請檢查您的垃圾郵件資料夾。'
                  : "Can't find our email? Check your spam folder."}
              </p>
              <a
                href="#home"
                className="inline-flex items-center gap-2 rounded-full border border-sorra-pink px-6 py-3 text-base font-medium text-sorra-pink transition hover:bg-sorra-pink hover:text-white"
              >
                Back to top
                <span>↑</span>
              </a>
            </div>
          ) : (
            <Formik
              initialValues={{
                attendees: [{ ...EMPTY_ATTENDEE }],
                painPoints: [],
              }}
              validationSchema={registrationSchema}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form
                  className="rounded-3xl border border-white p-6 shadow-lg lg:p-12"
                  style={{
                    background:
                      'linear-gradient(to bottom, #FFFFFF 0%, #FCE1E5 100%)',
                  }}
                >
                  {/* Header */}
                  <h2
                    className="mb-1 inline-block font-rubik text-3xl font-bold uppercase lg:text-4xl"
                    style={{
                      background:
                        'linear-gradient(94deg, #FF7C92 16.71%, #FFB68C 95.36%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  >
                    {t.regTitle}
                  </h2>
                  <br />
                  <p
                    className="block inline-block text-sm lg:mb-6"
                    style={{
                      background:
                        'linear-gradient(94deg, #FF7C92 16.71%, #FFB68C 95.36%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  >
                    {t.regSubtitle}
                  </p>

                  <FieldArray name="attendees">
                    {({ push, remove }) => (
                      <>
                        {values.attendees.map((_, idx) => {
                          const prefix = `attendees.${idx}`;
                          const err = errors.attendees?.[idx] || {};
                          const tch = touched.attendees?.[idx] || {};
                          return (
                            <div key={idx} className="mb-6">
                              <label className="mb-2 mt-6 block text-sm font-bold text-sorra-gray-900">
                                {t.regAttendeeName(idx + 1)}
                              </label>
                              <Field
                                name={`${prefix}.name`}
                                placeholder={t.phName(idx + 1)}
                                className={`${INPUT_CLASS} mb-1`}
                              />
                              {tch.name && err.name && (
                                <p className={ERROR_CLASS}>{err.name}</p>
                              )}

                              <div className="mb-6 mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
                                <div>
                                  <label className="mb-2 block text-sm font-bold text-sorra-gray-900">
                                    {t.regCompany}
                                  </label>
                                  <Field
                                    name={`${prefix}.company`}
                                    placeholder={t.phCompany}
                                    className={INPUT_CLASS}
                                  />
                                  {tch.company && err.company && (
                                    <p className={ERROR_CLASS}>{err.company}</p>
                                  )}
                                </div>
                                <div>
                                  <label className="mb-2 block text-sm font-bold text-sorra-gray-900">
                                    {t.regJobTitle}
                                  </label>
                                  <Field
                                    name={`${prefix}.jobTitle`}
                                    placeholder={t.phJobTitle}
                                    className={INPUT_CLASS}
                                  />
                                  {tch.jobTitle && err.jobTitle && (
                                    <p className={ERROR_CLASS}>
                                      {err.jobTitle}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <div className="mb-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
                                <div>
                                  <label className="mb-2 block text-sm font-bold text-sorra-gray-900">
                                    {t.regEmail}
                                  </label>
                                  <Field
                                    name={`${prefix}.email`}
                                    type="email"
                                    placeholder={t.phEmail}
                                    className={INPUT_CLASS}
                                  />
                                  {tch.email && err.email && (
                                    <p className={ERROR_CLASS}>{err.email}</p>
                                  )}
                                </div>
                                <div>
                                  <label className="mb-2 block text-sm font-bold text-sorra-gray-900">
                                    {t.regPhone}
                                  </label>
                                  <Field
                                    name={`${prefix}.phone`}
                                    type="tel"
                                    placeholder={t.phPhone}
                                    className={INPUT_CLASS}
                                  />
                                  {tch.phone && err.phone && (
                                    <p className={ERROR_CLASS}>{err.phone}</p>
                                  )}
                                </div>
                              </div>

                              {/* Remove (non-last attendees) */}
                              {idx < values.attendees.length - 1 && (
                                <button
                                  type="button"
                                  onClick={() => remove(idx)}
                                  className="mt-3 flex items-center gap-1 text-sm font-medium text-sorra-pink"
                                >
                                  <span className="text-lg font-bold lg:mr-2">
                                    ✕
                                  </span>
                                  <span className="text-base font-bold">
                                    {t.regRemove(idx + 1)}
                                  </span>
                                </button>
                              )}

                              {idx === values.attendees.length - 1 && (
                                <div className="mb-4 mt-3 flex items-center gap-6">
                                  {idx > 0 && (
                                    <button
                                      type="button"
                                      onClick={() => remove(idx)}
                                      className="flex items-center gap-1 text-sm font-medium text-sorra-pink"
                                    >
                                      <span className="text-lg font-bold lg:mr-2">
                                        ✕
                                      </span>
                                      <span className="text-base font-bold">
                                        {t.regRemove(idx + 1)}
                                      </span>
                                    </button>
                                  )}
                                  <button
                                    type="button"
                                    onClick={() => push({ ...EMPTY_ATTENDEE })}
                                    className={`flex items-center gap-1 text-sm font-medium text-sorra-pink ${values.attendees.length >= 3 ? 'cursor-not-allowed opacity-60' : ''}`}
                                    disabled={values.attendees.length >= 3}
                                  >
                                    <span className="text-lg lg:mr-2">+</span>
                                    <span className="text-base font-bold">
                                      {values.attendees.length >= 3
                                        ? t.regAddMax
                                        : t.regAdd}
                                    </span>
                                  </button>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </>
                    )}
                  </FieldArray>

                  {/* Pain Points */}
                  <div className="mb-8 mt-6">
                    <p className="mb-1 font-rubik text-base font-medium text-[#4A4A4A]">
                      {t.regPainPointTitle}
                      <br className="flex lg:hidden" />
                      <span className="mb-4 text-[12px] font-normal text-[#4A4A4A] lg:ml-2">
                        {t.regPainPointSub}
                      </span>
                    </p>
                    <div className="flex flex-col gap-3">
                      {t.painPoints.map((point) => {
                        const selected = values.painPoints.includes(point);
                        return (
                          <button
                            key={point}
                            type="button"
                            onClick={() => {
                              const next = selected
                                ? values.painPoints.filter((p) => p !== point)
                                : [...values.painPoints, point];
                              setFieldValue('painPoints', next);
                            }}
                            className={`flex items-center gap-3 rounded-xl bg-white px-4 py-5 text-left text-sm transition lg:text-base ${
                              selected
                                ? 'border border-sorra-pink font-medium text-sorra-gray-900'
                                : 'border border-gray-200 font-normal text-sorra-gray-800'
                            }`}
                          >
                            <span className="min-w-0 grow">{point}</span>
                            <span className="shrink-0">
                              {selected ? (
                                <span className="flex h-5 w-5 items-center justify-center rounded-md bg-sorra-pink text-white">
                                  ✓
                                </span>
                              ) : (
                                <span className="block h-5 w-5 rounded-md border-2 border-gray-300" />
                              )}
                            </span>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="flex w-full items-center justify-center gap-2 rounded-xl bg-sorra-pink py-6 text-base font-semibold text-white transition hover:bg-sorra-pink/90 disabled:opacity-50"
                  >
                    {isSubmitting ? t.regSubmitting : t.regSubmit}
                    {!isSubmitting && (
                      <div className="h-5 w-5">
                        <ArrowRightSvg color="#FFFFFF" />
                      </div>
                    )}
                  </button>

                  <div className="mt-6 text-center text-xs font-medium text-[#4A4A4A]">
                    <p>{t.regDisclaimer1}</p>
                    <p>{t.regDisclaimer2}</p>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </div>
      </MaxWidthContainer>
    </section>
  );
}

export default SeminarPage;
